import { render, staticRenderFns } from "./CreateLessonDialog.vue?vue&type=template&id=3d6da806&"
import script from "./CreateLessonDialog.vue?vue&type=script&lang=ts&"
export * from "./CreateLessonDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports